// extracted by mini-css-extract-plugin
module.exports = {"ProductActionsUIWrapper":"ProductActionsUI_ProductActionsUIWrapper___Sw_l"};